package one.devsbox.commons

import kotlinx.datetime.LocalDateTime
import kotlinx.datetime.LocalDate
import kotlinx.datetime.number
import kotlinx.serialization.KSerializer
import kotlinx.serialization.descriptors.PrimitiveKind
import kotlinx.serialization.descriptors.PrimitiveSerialDescriptor
import kotlinx.serialization.descriptors.SerialDescriptor
import kotlinx.serialization.encoding.Decoder
import kotlinx.serialization.encoding.Encoder

object KdbLocalDateTimeSerializer : KSerializer<LocalDateTime> {
    override val descriptor: SerialDescriptor =
        PrimitiveSerialDescriptor("LocalDateTime", PrimitiveKind.STRING)

    override fun serialize(encoder: Encoder, value: LocalDateTime) {
        // .toString() in kotlinx.datetime always produces ISO-8601 (yyyy-MM-ddTHH:mm:ss...)
        encoder.encodeString(value.toString())
    }

    override fun deserialize(decoder: Decoder): LocalDateTime {
        val input = decoder.decodeString().trim()

        // 1. Convert "YYYY-MM-DD HH:MM:SS" -> "YYYY-MM-DDTHH:MM:SS"
        // This satisfies the MariaDB space issue.
        val normalized = input.replace(" ", "T")

        return try {
            if (normalized.length <= 10) {
                // Case: "2026-04-11"
                val date = LocalDate.parse(normalized)
                LocalDateTime(date.year, date.month.number, date.day, 0, 0, 0, 0)
            } else {
                // Case: "2026-04-11T16:08:14"
                LocalDateTime.parse(normalized)
            }
        } catch (e: IllegalArgumentException) {
            // Fallback for truncated times like "2026-04-11T16"
            // If MariaDB gives you weird formats, you can add more logic here.
            throw e
        }
    }
}